import {
  JUDGE_2,
  JUDGE_3,
  JUDGE_4,
  JUDGE_5,
  JUDGE_6,
  JUDGE_7,
  REGISTRAR_1,
  REGISTRAR_2,
  REGISTRAR_3,
} from "../assets";

export const faqData = [
  {
    id: 1,
    question:
      "How do I create an account on the Enugu State Customary Court of Appeal portal?",
    answer: `Visit the e-Probate Enugu platform and click "Sign Up". Fill in your personal details, provide a valid email address, create a secure password, and verify your account through the confirmation email sent to you.`,
  },
  {
    id: 2,
    question: "Can I update my personal details after registration?",
    answer:
      "By searching our database, you can avoid unknowingly purchasing a property with legal issues, protect yourself from financial loss and future litigation and make informed choices about property investments.",
  },
  {
    id: 3,
    question: "What should I do if I forget my password?",
    answer:
      'Lis pendens is a Latin term meaning "suit pending." It refers to a lawsuit involving the ownership or rights to a specific property. A lis pendens notice is filed in the land registry to alert potential buyers of the ongoing legal dispute.',
  },
  {
    id: 4,
    question: "Can I use one account for multiple probate applications?",
    answer:
      "You can search our database using various criteria, such as property address, certificate of occupancy number, or owner's name.",
  },
  {
    id: 5,
    question: "How do I deactivate or delete my account?",
    answer:
      "The search results will indicate if a property has a lis pendens or other encumbrances registered against it. It may also provide brief details about the nature of the lawsuit or encumbrance.",
  },
  {
    id: 6,
    question: "Is my personal information safe on the platform?",
    answer:
      "If a property has a lis pendens, it's advisable to consult with a lawyer to understand the potential risks involved before proceeding with the purchase.",
  },
  {
    id: 7,
    question: "Can I change the email address linked to my account?",
    answer:
      "For sustainability, we are a paid service. For a fee we allow you to search our database for properties you might be interested in to find out if they may be the subject of a suit. Where there's a match, we provide you with the suit details or nature of known encumbrance on the property.",
  },
  {
    id: 8,
    question: "Do I need to verify my email before using the service?",
    answer:
      "Enugu e-Lis Pendens is an informational service and does not provide legal advice. We recommend consulting with a qualified lawyer for legal guidance on specific property issues.",
  },
  {
    id: 9,
    question: "What happens if my account is locked or suspended?",
    answer:
      "Our core function is searching for existing lis pendens filings. We may be able to provide information on the process of filing a lis pendens notice, but it's always best to consult with a lawyer for this purpose.",
  },
  {
    id: 10,
    question: "Can I access my account from multiple devices?",
    answer:
      "Our core function is searching for existing lis pendens filings. We may be able to provide information on the process of filing a lis pendens notice, but it's always best to consult with a lawyer for this purpose.",
  },
];

export const footer = [
  {
    title: "Quick Links",
    links: [
      {
        title: "Home",
        link: "",
      },
      {
        title: "Court History",
        link: "",
      },
      {
        title: "News & Events",
        link: "",
      },
      {
        title: "Picture Gallery",
        link: "",
      },
      {
        title: "Structure of the court",
        link: "",
      },
    ],
  },
  {
    title: "Court Links",
    links: [
      {
        title: "State High Court",
        link: "",
      },
      {
        title: "Magistrate Courts",
        link: "",
      },
      {
        title: "Multi‑Door Courthouse",
        link: "",
      },
      {
        title: "Small Claims Court",
        link: "",
      },
    ],
  },
  {
    title: "Contact Info",
    links: [
      {
        title: `No. 5, Aguleri Street Independence Layout, P.M.B 1461, Enugu State`,
        link: "",
      },
      {
        title: "Email: info@cca.en.gov.ng",
        link: "",
      },
      {
        title: "Phone: +234 809 4906 0890",
        link: "",
      },
    ],
  },
];

export const Judges = [
  {
    name: "Hon. Justice Emmanuel Nnaji Nnamani (PhD)",
    role: "Judge, Customary Court of Appeal, Enugu State",
    image: JUDGE_2,
  },
  {
    name: "Hon. Justice C.A.B. Onaga",
    role: "Judge, Customary Court of Appeal, Enugu State",
    image: JUDGE_3,
  },
  {
    name: "Hon. Justice P. A. Obayi",
    role: "Judge, Customary Court of Appeal, Enugu State",
    image: JUDGE_4,
  },
  {
    name: "Hon. Justice Jacinta Ugonne Nweze",
    role: "Judge, Customary Court of Appeal, Enugu State",
    image: JUDGE_5,
  },
  {
    name: "Hon. Justice Nnenna Celia Madu",
    role: "Judge, Customary Court of Appeal, Enugu State",
    image: JUDGE_6,
  },
  {
    name: "Hon. Justice E. R. Ogbodo (Ph.D)",
    role: "Judge, Customary Court of Appeal, Enugu State",
    image: JUDGE_7,
  },
];
export const ChiefRegistrar = [
  {
    name: "His Worship Iheobuna Sparkle Oji",
    role: "Chief Registrar",
    image: REGISTRAR_1,
  },
  {
    name: "Barr. T.S. Ugwuja",
    role: "Deputy Chief Registrar",
    image: REGISTRAR_2,
  },
  {
    name: "Barr. J.K. Ezeh",
    role: "Deputy Chief Registrar 2",
    image: REGISTRAR_3,
  },
];

export const TableData = [
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
  {
    date: "13/09/2022",
    appeal_no: "A/ABJ/CV/803/2021",
    parties: "PETROL LOGISTICS LTD & ANOR. AND JENNIFER DOUGLAS ABUBAKAR",
    nature: "CIVIL",
    business_of_the_day: "MOTION",
  },
];
